import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"

import { ContentContainer } from "./styled"
import { MenuItem } from "../../components/MenuItem"
import {
  setCurrentFlow,
  setCurrentStep,
} from "../../store/slices/routingSlice/routingSlice"
import { ROUTES_PATHS } from "../../utils/constants"
import { STEPS_NAME } from "../../store/slices/routingSlice/flowsSteps"

const TransferSelect = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleSBPClick = () => {
    dispatch(setCurrentFlow("c2cPush"))
    dispatch(setCurrentStep(STEPS_NAME.c2cPush.getLastTransfers))
    navigate(`/${ROUTES_PATHS.pushC2c}`)
  }

  return (
    <ContentContainer>
      <MenuItem
        icon="sbpBox"
        title="Другому человеку"
        subtitle="По номеру телефона через СБП"
        onClick={handleSBPClick}
      />
      <MenuItem icon="creditCard" title="По номеру карты" />
    </ContentContainer>
  )
}

export default TransferSelect
